<template>
    <div>
        <navbar :title="text_title"></navbar>
        <ul>
            <li>R币：{{ this.usermoney.money }}</li>
            <li>R点:{{ this.usermoney.coin }}(时效R点:{{ this.usermoney.time_coin }})</li>
            <li>R点兑换</li>
        </ul>
    </div>
</template>

<script>
import navbar from '../../components/Navbar'
export default {
    components:{
        navbar
    },
    data(){
        return{
        text_title:'我的钱包',
        text:'充值记录',
        usermoney:'',
        }
    },
    mounted(){
        this.usermoney =  this.$route.query.usermoney;
    },
}
</script>

<style scoped>
ul{
    background-color: #fff;
    text-align: center;
    margin-bottom: 20px;
}
li:first-child{
    line-height: 28px;
    padding-top: 20px;
    color: rgba(249, 88, 85, 1);
    font-size: 20px;
}
li:nth-child(2){
    line-height: 30px;
    color: rgba(249, 88, 85, 1);
    font-size: 13px;
}
li:last-child{
    width: 80px;
    margin: 15px auto;
    line-height: 28px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 14px;
    font-size: 12px;    
}
</style>


// WEBPACK FOOTER //
// src/pages/money/money.vue